__turbopack_context__.v({
  "clearableInputContainer": "UrlAnalysis-module-scss-module__aJ1D4a__clearableInputContainer",
  "date": "UrlAnalysis-module-scss-module__aJ1D4a__date",
  "description": "UrlAnalysis-module-scss-module__aJ1D4a__description",
  "green": "UrlAnalysis-module-scss-module__aJ1D4a__green",
  "heading": "UrlAnalysis-module-scss-module__aJ1D4a__heading",
  "info": "UrlAnalysis-module-scss-module__aJ1D4a__info",
  "inputField": "UrlAnalysis-module-scss-module__aJ1D4a__inputField",
  "line": "UrlAnalysis-module-scss-module__aJ1D4a__line",
  "radioGroup": "UrlAnalysis-module-scss-module__aJ1D4a__radioGroup",
  "radioLabel": "UrlAnalysis-module-scss-module__aJ1D4a__radioLabel",
  "res": "UrlAnalysis-module-scss-module__aJ1D4a__res",
  "rescan": "UrlAnalysis-module-scss-module__aJ1D4a__rescan",
  "resultHeading": "UrlAnalysis-module-scss-module__aJ1D4a__resultHeading",
  "resultInfo": "UrlAnalysis-module-scss-module__aJ1D4a__resultInfo",
  "resultTitle": "UrlAnalysis-module-scss-module__aJ1D4a__resultTitle",
  "searchBtn": "UrlAnalysis-module-scss-module__aJ1D4a__searchBtn",
  "sideLabel": "UrlAnalysis-module-scss-module__aJ1D4a__sideLabel",
  "status": "UrlAnalysis-module-scss-module__aJ1D4a__status",
  "url": "UrlAnalysis-module-scss-module__aJ1D4a__url",
  "urlContainer": "UrlAnalysis-module-scss-module__aJ1D4a__urlContainer",
  "urlInfo": "UrlAnalysis-module-scss-module__aJ1D4a__urlInfo",
  "urlInnerCont": "UrlAnalysis-module-scss-module__aJ1D4a__urlInnerCont",
  "validatorText": "UrlAnalysis-module-scss-module__aJ1D4a__validatorText",
  "verticalLine": "UrlAnalysis-module-scss-module__aJ1D4a__verticalLine",
  "warningText": "UrlAnalysis-module-scss-module__aJ1D4a__warningText",
});
